// extracted by mini-css-extract-plugin
export default {"root":"Z0fA5","myMessage":"PLAMm","firstInGroup":"jWnGI","lastInGroup":"KBTb1","mobile":"BaeVM","description":"dTBGy","descriptionText":"_hX81","button":"V9Nqo","spinner":"TlWVE"};